/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Profile",
  presignedUrl
  
}) {
let appointmentBookingPatientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'patient_person',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="appointment_booking.patient_person"
 format="/Data/format.js initials"
 initials={appointmentBookingPatientPersonValueData}
 size="medium"
 marginRight={dtSpaceXs}
 cursor="pointer"
/>
{children}
</React.Fragment>)
}